import bagoutComponent from './bagout.component';
import printBagoutComponent from './print/print.component';

let bagoutModule = angular.module('bagout', [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/bag-out');

    $stateProvider
      .state('bagout', {
        url: '/bag-out',
        component: 'bagout',
        data: {
          requireLogin: true,
          requireACL: 'bag_out.all'
        },
        parent: 'app',
      })
      .state('bagoutPrint', {
        url: '/bag-out-print',
        component: 'printBagout',
        data: {
          requireLogin: true,
          requireACL: 'bag_out.all'
        },
        parent: 'app',
      });
  })

  .component('bagout', bagoutComponent)
  .component('printBagout', printBagoutComponent)

  .name;

export default bagoutModule;


// WEBPACK FOOTER //
// ./client/app/components/bagout/index.js